import { BiCoffeeTogo } from "react-icons/bi";
import { HiCode } from "react-icons/hi";
import { ImHeadphones, ImBooks } from "react-icons/im";
import { TiCamera } from "react-icons/ti";
import { IoIosBicycle } from "react-icons/io";
import { Popup } from 'semantic-ui-react'

import pfp from "../../img/me.png";

import "./about.css";
import { useEffect } from "react";
const AOS = require('aos');


const About = () => {

    useEffect(() => {
        AOS.init({
          duration : 1200
        });
      }, []);

    return (
        <div id="about-sec">
        <div>
            <p className="heading sec">About <strong>Me</strong></p>
            </div>
            <div className="circle">
                <span className="circle__btn ">
                    <img src={pfp} alt="Tathagat Priyadarshi" />
                </span>
                <span className="circle__back-1"></span>
                <span className="circle__back-2"></span>
            </div>
        <div className="col-grid">
            <div className="col">
                <div data-aos="fade-left" data-aos-duration="1500" className="boxed card">
                        <p>
                            
                        <span className="about-intro">
                            A keen learner,<br /> 
                            a universe of atoms, <br />
                            atoms of curiosity.
                        </span>
                            <br />
                            
                            Hello!! I am <strong>Tathagat Priyadarshi</strong>, an enthusiastic Final year B.Tech student with an insatiable passion for cutting-edge technology and wholeheartedly devoted to mastering Web and Android/iOS development. I warmly welcome guidance from seasoned experts to further fuel my quest for excellence and scale new heights.
                            
                            <br />
                        <br />
                        <br />
                        <br />

                            <i>
                                <br />Stop Going through Life,
                                <br />Start Growing through Life!<br /></i>
                        <div className="button" onClick={() => window.open("mailto:priyadarshi1131@gmail.com")}>
                            Get in touch
                        </div>
                        
                    </p>
                </div>
            </div>
            
            <div className="col">
                <div data-aos="zoom-in-right" data-aos-duration="1100" className="boxed details card">
                    <p className="bio">He / Him</p>
                </div>

                <div data-aos="zoom-in-right" data-aos-duration="1300" className="boxed details card">
                    <p className="bio">22 years old</p>
                </div>

                <div data-aos="zoom-in-right" data-aos-duration="1500" className="boxed details card">
                    <p className="bio">Aquarius</p>
                </div>
            
                <div className="hobbies">
                    
                    <Popup
                        trigger={
                            <span data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1200" className="material-icons">
                                <BiCoffeeTogo color="#c7666c" fontSize="25px"/>
                            </span>
                        }
                        content={<div>Coffee<br />Coffee<br />Coffee</div>}
                        className="popped"
                        position='bottom center'
                    />

                    <Popup
                        trigger={
                            <span data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1500" className="material-icons">
                                <ImHeadphones color="#c7666c" fontSize="25px"/>
                            </span>
                        }
                        content='All Genre Songs'
                        className="popped"
                        position='bottom center'
                    />
                    
                    <Popup
                        trigger={
                            <span data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1800" className="material-icons">
                                <TiCamera color="#c7666c" fontSize="25px"/>
                            </span>
                        }
                        content='Romanticizing Life through my camera'
                        className="popped"
                        position='bottom center'
                    />
                    
                    <Popup
                        trigger={
                            <span data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1800" className="material-icons">
                                <IoIosBicycle color="#c7666c" fontSize="25px"/>
                            </span>
                        }
                        content='Cycling through Streets'
                        className="popped"
                        position='bottom center'
                    />

                    <Popup
                        trigger={
                            <span data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1800" className="material-icons">
                                <ImBooks color="#c7666c" fontSize="25px"/>
                            </span>
                        }
                        content={"Reading Novels"}
                        className="popped"
                        position='bottom center'
                    />
                    

                    

                    
                    
                </div>
            </div>

        </div>
        </div>
    )
}

export default About